<template>
<div>
    <Breadcrumbs main="Project" title="Projects" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 project-list">
                <div class="card">
                    <div class="row m-0">
                        <div class="col-sm-12 p-0">
                            <b-tabs content-class="mt-3" v-model="tabIndex">
                                    <b-tab title="Archived" :title-link-class="category === 'ARCHIVED' ? 'text-success' : ''" @click="categoryType('ARCHIVED')">
                                    <template v-slot:title>
                                        <div>
                                            <feather type="compass"></feather> Archived
                                        </div>
                                    </template>

                                    <b-card-text>
                                        <div class="col-sm-12 p-0">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row mb-4">
                                                        <div style="display: flex; flex-direction: row; justify-content: space-between" class="col-xl-12">
                                                            <b-input-group class="col-xl-4">
                                                                <b-form-input v-model="query" placeholder="Type to Search" @keyup.enter="findProjects()"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button @click="findProjects()">Search</b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                            <div style="display: flex; gap:15px">
                                                                <feather type="list" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="List View" @click="toggleGrid"> </feather>
                                                                <feather type="grid" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Grid View" @click="toggleList"> </feather>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="!loading && !error">
                                                        <div class="row" v-if="projects.length > 0">
                                                            <div v-if="showGrid" class="col-xl-4 col-lg-6" v-for="(project, index) in projects" :key="index" :class="index < 3 ? 'mb-4' : 'mb-4'">
                                                                <div class="project-box">
                                                                    <div class="my-4">
                                                                        <span v-if="project.status == 'APPROVED'" class="badge" :class="'badge-primary'" @click="getStatus(project.status, project.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ project.status }}</span>
                                                                        <span v-if="project.status == 'PENDING'" class="badge" :class="'badge-danger'" @click="getStatus(project.status, project.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ project.status }}</span>
                                                                        <span v-if="project.status == 'ARCHIVED'" class="badge" :class="'badge-info'" @click="getStatus(project.status, project.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ project.status }}</span>
                                                                        <span v-if="project.status == 'COMPLETED'" class="badge" :class="'badge-success'" @click="getStatus(project.status, project.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ project.status }}</span>
                                                                    </div>

                                                                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                                        <router-link :to="{ path: '/project/details/' + project.id }" class="link-style">
                                                                            <h6 class="box">{{ project.title }}</h6>
                                                                        </router-link>
                                                                        <div style="display: flex;flex-direction: row; gap: 5px;">
                                                                            <router-link :to="{ path: '/project/edit/' + project.id }">
                                                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                                                            </router-link>
                                                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-password @click="deleteProject(project.id)" title="Delete"></feather>
                                                                        </div>
                                                                    </div>
                                                                    <div style="display: flex; align-items: start; justify-content: flex-start;">
                                                                        <h7 class="badge-pill badge-danger ">{{ project.deadline }}</h7>
                                                                    </div>
                                                                    <div style="display: flex; align-items: start; justify-content: flex-start; margin-top: 4px;" v-if="project.category">
                                                                        <h7 class=""><span style="font-weight: 500;">Project Type: </span> {{ project?.category?.title }}</h7>
                                                                    </div>
                                                                    <div style="display: flex; align-items: start; justify-content: flex-start; margin-top: 4px;" v-if="project.reference_id">
                                                                        <h7 class=""><span style="font-weight: 500;">Reference ID: </span> {{ project.reference_id }}</h7>
                                                                    </div>

                                                                    <!-- <div v-if="project.details.length < 200" v-html="project.details"></div> -->
                                                                    <div class="mt-3" v-html="project.details" style="height: 200px; overflow: hidden; text-overflow: ellipsis;"></div>

                                                                    <div class="mt-3 row details">
                                                                        <div class="col-6">
                                                                            <span>Tasks</span>
                                                                        </div>
                                                                        <div v-if="project.status == 'APPROVED'" class="col-6" style="color: #1c1c1c;">{{ project.task }}</div>
                                                                        <div v-if="project.status == 'PENDING'" class="col-6" :class="'text-danger'">{{ project.task }}</div>
                                                                        <div v-if="project.status == 'ARCHIVED'" class="col-6" style="color: #a426f2;">{{ project.task }}</div>
                                                                        <div v-if="project.status == 'COMPLETED'" class="col-6" :class="'text-success'">{{ project.task }}</div>
                                                                        <div class="col-6">
                                                                            <span>Resolved</span>
                                                                        </div>
                                                                        <div v-if="project.status == 'APPROVED'" class="col-6" style="color: #1c1c1c;">{{ project.resolved }}</div>
                                                                        <div v-if="project.status == 'PENDING'" class="col-6" :class="'text-danger'">{{ project.resolved }}</div>
                                                                        <div v-if="project.status == 'ARCHIVED'" class="col-6" style="color: #a426f2;">{{ project.resolved }}</div>
                                                                        <div v-if="project.status == 'COMPLETED'" class="col-6" :class="'text-success'">{{ project.resolved }}</div>
                                                                        <div class="col-6">
                                                                            <span>Remaining</span>
                                                                        </div>
                                                                        <div v-if="project.status == 'APPROVED'" class="col-6" style="color: #1c1c1c;">{{ project.remaining }}</div>
                                                                        <div v-if="project.status == 'PENDING'" class="col-6" :class="'text-danger'">{{ project.remaining }}</div>
                                                                        <div v-if="project.status == 'ARCHIVED'" class="col-6" style="color: #a426f2;">{{ project.remaining }}</div>
                                                                        <div v-if="project.status == 'COMPLETED'" class="col-6" :class="'text-success'">{{ project.remaining }}</div>
                                                                    </div>

                                                                    <div class="customers mt-3" v-if="project.teammates.length > 0">
                                                                        <ul v-for="(team, index) in project.teammates" :key="index">
                                                                            <li class="d-inline-block" v-if="team.user_id.additional_info">
                                                                                <img class="img-30 rounded-circle" :src="host + team.user_id.additional_info.photo" :class="{ 'border-blue': team.project_lead }" alt="" v-b-tooltip.hover :title="team.user_name">
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                    <div class="project-status mt-3">
                                                                        <div class="media mb-0">
                                                                            <p>{{projectDoneTaskPercentage(project)}}%</p>
                                                                            <div class="media-body text-right">
                                                                                <span>Done</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="progress" style="height: 5px">
                                                                            <div v-if="project.status == 'APPROVED'" class="progress-bar-animated progress-bar-striped" :class="'bg-primary'" role="progressbar" :style="{'width':  projectDoneTaskPercentage(project) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                                            <div v-if="project.status == 'PENDING'" class="progress-bar-animated progress-bar-striped" :class="'bg-danger'" role="progressbar" :style="{'width':  projectDoneTaskPercentage(project) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                                            <div v-if="project.status == 'ARCHIVED'" class="progress-bar-animated progress-bar-striped" :class="'bg-info'" role="progressbar" :style="{'width':  projectDoneTaskPercentage(project) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                                            <div v-if="project.status == 'COMPLETED'" class="progress-bar-animated progress-bar-striped" :class="'bg-success'" role="progressbar" :style="{'width':  projectDoneTaskPercentage(project) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-if="showList" class="col-xl-12">
                                                                <b-row>
                                                                    <b-col xl="12">
                                                                        <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                                                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                                                        </b-form-group>
                                                                    </b-col>
                                                                </b-row>

                                                                <div class="table-responsive datatable-vue">
                                                                    <b-table show-empty stacked="md" :items="projects" :fields="tablefields" :filter="filter" :per-page="perPage">
                                                                        <template #cell(index)="data">
                                                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                                                        </template>

                                                                        <template #cell(title)="data">
                                                                            <span style="display: flex; flex-direction: column; gap: 4px;">
                                                                                <router-link :to="{ path: '/project/details/' + data.item.id }" class="link-style" style="font-size:14px; max-width: 390px;">{{data.item.title}}</router-link>
                                                                                <small><span style="font-size: medium;">
                                                                                        <span v-if="data.item.status == 'APPROVED'" class="badge" :class="'badge-primary'" @click="getStatus(data.item.status, data.item.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ data.item.status }}</span>
                                                                                        <span v-if="data.item.status == 'PENDING'" class="badge" :class="'badge-danger'" @click="getStatus(data.item.status, data.item.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ data.item.status }}</span>
                                                                                        <span v-if="data.item.status == 'ARCHIVED'" class="badge" :class="'badge-info'" @click="getStatus(data.item.status, data.item.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ data.item.status }}</span>
                                                                                        <span v-if="data.item.status == 'COMPLETED'" class="badge" :class="'badge-success'" @click="getStatus(data.item.status, data.item.id)" v-b-modal.modal-prevent-closing-status v-b-tooltip.hover title="Update Status">{{ data.item.status }}</span>
                                                                                    </span>
                                                                                </small>
                                                                                <span v-if="data.item.category"><span style="font-weight: 500;">Project Type:</span> {{data.item.category.title}}</span>
                                                                                <span v-if="data.item.reference_id"><span style="font-weight: 500;">Reference ID:</span> {{data.item.reference_id}}</span>
                                                                            </span>
                                                                        </template>

                                                                        <template #cell(date)="data">
                                                                            <div class="d-flex flex-column">
                                                                                <span>Start Date:</span>
                                                                                <div class="badge badge-primary" style="max-width:fit-content">{{ data.item.start_date }}</div>
                                                                                <span style="margin-top: 8px;">Deadline:</span>
                                                                                <div class="badge badge-danger" style="max-width:fit-content">{{ data.item.deadline }}</div>
                                                                            </div>
                                                                        </template>

                                                                        <template #cell(teammember)="data">
                                                                            <span>
                                                                                <div v-if="data.item.teammates !== null && data.item.teammates.length > 0">
                                                                                    <div class="customers">
                                                                                        <ul>
                                                                                            <ul v-for="(member, index) in data.item.teammates.slice(0,8)" :key="index">
                                                                                                <li v-if="member.user_id.additional_info.photo" class="d-inline-block" v-b-tooltip.hover :title="member.user_name"><img class="img-30 rounded-circle" :src="host + member.user_id.additional_info.photo" :class="{ 'border-blue': member.project_lead }" alt="" data-original-title=""></li>
                                                                                                <li v-else class="d-inline-block" v-b-tooltip.hover :title="member.user_name"><img class="img-30 rounded-circle" src="../../../assets/images/user/3.jpg" alt="" data-original-title=""></li>
                                                                                            </ul>
                                                                                            <li class="d-inline-block mr-2" v-if="data.item.teammates.length > 8">
                                                                                                <p class="f-12">+ {{ data.item.teammates.length - 8 }}</p>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else>
                                                                                    <p>N/A</p>
                                                                                </div>
                                                                            </span>
                                                                        </template>

                                                                        <template #cell(task)="data">
                                                                            <div class="d-flex flex-column">
                                                                                <div style="color: #1c1c1c;">Task: {{ data.item.task }}</div>
                                                                                <div style="color: #1c1c1c;">Resolved: {{ data.item.resolved }}</div>
                                                                                <div style="color: #1c1c1c;">Remaining: {{ data.item.remaining }}</div>
                                                                            </div>
                                                                        </template>

                                                                        <template #cell(client_name)="data">
                                                                            <div style="min-width: 180px;">
                                                                                <div v-if="data.item.company">
                                                                                    <p> <span style="font-weight: 500;">Client Company:</span> {{ data.item.company.name }}</p>
                                                                                </div>
                                                                                <div v-for="client in data.item.client_name.slice(0,1)" :key="client.client_id" style="width:150px">
                                                                                    <span>{{client.client_name}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </template>

                                                                        <template #cell(action)="data">
                                                                            <span style="display: flex; gap: 12px;">
                                                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-password @click="deleteProject(data.item.id)" title="Delete"></feather>
                                                                                <router-link :to="`/project/edit/${data.item.id}`">
                                                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                                                                </router-link>
                                                                            </span>
                                                                        </template>
                                                                    </b-table>
                                                                </div>

                                                                <!-- <b-col md="6" class="my-1 p-0">
                                                                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                                                                </b-col> -->
                                                            </div>
                                                        </div>
                                                        <div v-else class="text-center">
                                                            <h6 style="margin-top: 60px;">No Project Found</h6>
                                                            <!-- <b-button style="margin-top: 16px;" variant="primary" @click="reloadProjects">Reload</b-button> -->
                                                        </div>
                                                    </div>
                                                    <div class="card" v-else>
                                                        <div class="loader-box">
                                                            <div class="loader-10"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-text>
                                </b-tab>

                               
                            </b-tabs>
                        </div>

                        <div class="col-sm-4 create-project-btn">
                            <div class="text-right">
                                <div class="d-flex align-items-center justify-content-end">
                                    <!-- <feather type="search" @click="toggleSearch" class="mr-4"></feather> -->
                                    <router-link to="create">
                                        <a class="btn btn-primary" href="">
                                            <i class="fa fa-light fa-plus" style="margin-right: 10px;"></i>
                                            <h7>Add New Project</h7>
                                        </a>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-row class="mt-3">
                        <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                            <span>
                                <!-- First Page Button (<<) -->
                                <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                    <b-icon icon="chevron-double-left"></b-icon>
                                </button>

                                <!-- Previous Page Button (<) -->

                                <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                    <b-icon icon="chevron-left"></b-icon>
                                </button>
                            </span>

                            <!-- Page Number Display (Page X of Y) -->
                            <span class="align-self-center">
                                <span class="align-self-center">
                                    <span class="d-flex align-items-center" style="gap: 6px;">
                                        <span>Page</span>
                                        <b-form-input v-model="currentPage" style="box-shadow: none; max-width: 40px;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                        <span>of {{ totalPages }}</span>
                                    </span>
                                </span>
                            </span>

                            <span>
                                <!-- Next Page Button (>) -->
                                <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                    <b-icon icon="chevron-right"></b-icon>
                                </button>

                                <!-- Last Page Button (>>) -->
                                <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                    <b-icon icon="chevron-double-right"></b-icon>
                                </button>
                            </span>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Project Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this project?</div>
    </b-modal>

    <!-- Update Priority -->
    <b-modal id="modal-center-password" centered ref="modal" title="Enter your password to continue" @ok="handlePasswordOk">
        <form ref="form" @submit.stop.prevent="handlePasswordSubmit">
            <b-form-group label="Password" label-for="name-input">
                <div style="position: relative; width: 100%;">
                    <div style="position: absolute; top: 0px; bottom: 0px; right: 0px; padding-right: 28px; display: flex; align-items: center;">
                        <i style="position: absolute; display: flex; justify-content: center; cursor: pointer;" :class="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </div>
                    <input :type="passwordFieldType" v-model="password" name="password" placeholder="Enter your password" class="form-control" />
                </div>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Client List -->
    <b-modal id="modal-prevent-closing-client" ref="modal" title="Client List" hide-footer>
        <div class="row">
            <div class="text-center col-sm-6 w-full" v-for="client in clientList" :key="client.client_id">
                <div class="w-100 mb-2 badge-style">
                    <h7>{{ client.client_name }}</h7>
                </div>
            </div>
        </div>
    </b-modal>
    <!-- Update Status -->
    <b-modal id="modal-prevent-closing-status" ref="modal" title="Update Project Status" @show="resetModal" @hidden="resetModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="formattedOptions"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from "../../../_helpers/host";

export default {
    data() {
        return {
            showGrid: true,
            showList: false,
            host: myHost.host,
            tabIndex: 0,
            delete_value: '',
            password: '',
            passwordFieldType: 'password',
            query: null,
            activeItem: 'ALL',
            showSearch: false,
            projects: [],
            clientList: [],
            category: '',
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Project',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'Start & End Date',
                    sortable: true
                },
                {
                    key: 'teammember',
                    label: 'Team Members',
                    sortable: true
                },
                {
                    key: 'client_name',
                    label: 'Client & Company',
                    sortable: true
                },
                {
                    key: 'task',
                    label: 'Task',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            filter: null,
            initialLoad: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 9,
            pageOptions: [9, 18, 36],
            selectedStatus: '',
            project_id: null,
            statuses: [{
                    id: 1,
                    name: 'Working',
                    value: 'WORKING'
                },
                {
                    id: 2,
                    name: 'Approved',
                    value: 'APPROVED'
                },
                {
                    id: 3,
                    name: 'Pending',
                    value: 'PENDING',
                },
                {
                    id: 4,
                    name: 'Completed',
                    value: 'COMPLETED',
                },
                {
                    id: 5,
                    name: 'Paused',
                    value: 'PAUSED',
                },
                {
                    id: 6,
                    name: 'Postponed',
                    value: 'POSTPONED',
                },
                {
                    id: 7,
                    name: 'Archived',
                    value: 'ARCHIVED',
                },

            ],
        }
    },

    watch: {
        allprojects(newValue, oldValue) {
            this.projects = this.allprojects
            this.totalRows = this.projects.length;
        },

        searchedProjects(newValue, oldValue) {
            this.projects = this.searchedProjects
        },
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }

                this.$router.replace({
                    path: '/project/archived-list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage,
                        project_status: this.$route.query.project_status
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("project/fetchPaginatedArchivedProject", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    project_status: this.$route.query.project_status,
                    search_term: this.$route.query.search_term
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/project/archived-list',
                    query: {
                        page: 1,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.currentPage = 1
                this.$store.dispatch("project/fetchPaginatedArchivedProject", {
                    perPage: newperPage,
                    currentPage: 1,
                    project_status: this.$route.query.project_status,
                    search_term: this.$route.query.search_term

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

    },

    computed: {
        ...mapState({
            allprojects: state => state.project.project_archived_paginated,
            loading: state => state.project.submitLoading,
            error: state => state.project.submitError,
            searchedProjects: state => state.project.project_by_search,
            count: state => state.project.project_archived_count,

        }),

        projectDoneTaskPercentage() {
            return (project) => {
                if (project.task == 0) {
                    const percentage = 0;
                    return percentage
                } else {
                    const percentage = ((project.task - project.remaining) / project.task) * 100;
                    return Math.floor(percentage);
                }
            };
        },

        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'fa fa-regular fa-eye' : 'fa fa-regular fa-eye-slash'
        },
        totalPages() {

            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1;
        },
        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        }
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage || !this.$route.query.project_status) {
                this.categoryType('ARCHIVED')
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        project_status: 'ARCHIVED'
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitialProject();

            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.category = this.$route.query.project_status

                this.fetchInitialProject();

            }
        }

    },

    methods: {

        getStatus(status, id) {
            this.project_id = id
            this.selectedStatus = status
        },
        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            this.$store.dispatch("project/updateProjectStatus", {
                id: this.project_id,
                status_for_change: this.selectedStatus,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                project_status: this.$route.query.project_status,
                search_term: this.$route.query.search_term,
                from_archived:true,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-status')
            })
        },

        fetchInitialProject() {
            this.$store.dispatch("project/fetchPaginatedArchivedProject", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                project_status: this.category
            }).then(() => {

                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },
        validatePage() {
            this.loadingPage = true;

            const totalPages = this.totalPages;

            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages;
            }

            this.loadingPage = false;
        },
        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        clientInformation(type) {
            this.clientList = type.client_name
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        toggleList() {
            this.showList = false;
            this.showGrid = true;
        },

        toggleGrid() {
            this.showGrid = false;
            this.showList = true;
        },

        clearSearch() {
            this.query = null
        },

        toggleSearch() {
            this.showSearch = !this.showSearch;
        },

        findProjects() {
            if (this.query.trim() !== '') {
                this.$store.dispatch('project/fetchPaginatedArchivedProject', {
                    project_status: this.category === 'ALL' ? null : this.category,
                    search_term: this.query,
                    currentPage: 1,
                    perPage: this.perPage,
                });
            } else {
                this.errorMessage = 'Please enter a valid search term';
            }
        },

        // reloadProjects() {
        //     this.query = null
        //     if (this.activeItem === 'ALL') {
        //         this.$store.dispatch("project/fetchPaginatedArchivedProject")
        //     } else {
        //         this.$store.dispatch("project/fetchPaginatedArchivedProject", this.activeItem)
        //     }
        // },

        categoryType(item) {
            if (this.query !== null) {
                this.query = null
            }
            this.category = item
            this.activeItem = item
            this.currentPage = 1
            this.perPage = 9
            if (item === 'ALL') {
                this.$router.replace({
                    path: '/project/archived-list',
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage,

                    }
                });
                this.$store.dispatch("project/fetchPaginatedArchivedProject", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            } else {
                this.$router.replace({
                    path: '/project/archived-list',
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        project_status: item
                    }
                });
                this.$store.dispatch("project/fetchPaginatedArchivedProject", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    project_status: item
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        },

        deleteProject(id) {
            this.delete_value = id
        },

        // linkClass(idx) {
        //     if (this.tabIndex === idx) {
        //         return ['text-success']
        //     } else {

        //     }
        // },

        handleDeleteOk() {
            this.$store.dispatch("project/deleteProject", {
                id: this.delete_value,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                project_status: this.$route.query.project_status,
                search_term: this.$route.query.search_term,
                from_archived:true,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-center')
            })
        },

        handlePasswordOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handlePasswordSubmit()
        },

        handlePasswordSubmit() {
            this.$store.dispatch("project/checkMyPassword", {
                password: this.password
            }).then(response => {
                if (response.code == 200) {
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-center')
                    })
                    this.password = ''
                } else {
                    this.password = ''
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-center-password')
            })
        }
    }
}
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.img-30 {
    width: 30px !important;
    height: 30px !important;
}
.border-blue {
    border: 3px solid #f42a6b; /* Bootstrap primary blue */
    padding: 2px; /* Optional: creates space between image and border */
    box-sizing: border-box;
}

.box {
    inline-size: 280px;
    overflow-wrap: break-word;
}

@media screen and (max-width: 1645px) {
    .box {
        inline-size: 250px;
    }
}

@media screen and (max-width: 1555px) {
    .box {
        inline-size: 230px;
    }
}

@media screen and (max-width: 1495px) {
    .box {
        inline-size: 210px;
    }
}

@media screen and (max-width: 1495px) {
    .box {
        inline-size: 190px;
    }
}

@media screen and (max-width: 1335px) {
    .box {
        inline-size: 170px;
    }
}

@media screen and (max-width: 1265px) {
    .box {
        inline-size: 150px;
    }
}

@media screen and (max-width: 1200px) {
    .box {
        inline-size: 250px;
    }
}

@media screen and (max-width: 991px) {
    .box {
        inline-size: 550px;
    }
}

@media screen and (max-width: 740px) {
    .box {
        inline-size: 400px;
    }
}

@media screen and (max-width: 590px) {
    .box {
        inline-size: 350px;
    }
}

@media screen and (max-width: 510px) {
    .box {
        inline-size: 300px;
    }
}

@media screen and (max-width: 460px) {
    .box {
        inline-size: 270px;
    }
}

@media screen and (max-width: 430px) {
    .box {
        inline-size: 240px;
    }
}

@media screen and (max-width: 400px) {
    .box {
        inline-size: 210px;
    }
}

@media screen and (max-width: 370px) {
    .box {
        inline-size: 190px;
    }
}

@media screen and (max-width: 350px) {
    .box {
        inline-size: 170px;
    }
}
</style>
